/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2022 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 10/21/22.
 */

function ServerInfoServiceConstructor(
    this: JS5Object,
    _: JS5Object,
    ServerInfoResourceFactory: JS5Object
) {
    this.serverInfoPromise = null;
    this.timezoneOffsetMillis = null;

    this.queryForServerInfo = () => {
        if (!this.serverInfoPromise) {
            this.serverInfoPromise = ServerInfoResourceFactory.get().$promise.then((data: JS5Object) => {
                this.timezoneOffsetMillis = _.chain(data)
                    .get('timezoneOffsetMillis', '0')
                    .parseInt()
                    .value();
                return data;
            });
        }
        return this.serverInfoPromise;
    };

    this.getServerTimezoneOffsetMillis = () => {
        if (this.timezoneOffsetMillis === null) {
            console.error('getServerTimezoneOffsetMillis() expected serverInfo to return successfully');
            return 0;
        }
        return this.timezoneOffsetMillis;
    };
}

angular
    .module('prism-ui.components.data')
    .service('ServerInfoService', ServerInfoServiceConstructor);
